import React from 'react';
import { Link } from 'react-router-dom';
import { cookiePolicy, privacyPolicy, LEGAL_UPDATED_AT, LEGAL_SOURCES } from '../content/legalPolicies';
import './legalPolicy.css';
import { useCookieConsent } from '../context/CookieConsentContext';

const LegalPolicy = ({ kind = 'privacy' }) => {
  const { openPreferences } = useCookieConsent();
  const policy = kind === 'cookies' ? cookiePolicy : privacyPolicy;
  return (
    <div className="legal-page">
      <article className="legal-document">
        <header>
          <p className="legal-kicker">WebinarPlus · Informative</p>
          <h1>{policy.title}</h1>
          <p className="legal-updated">Ultimo aggiornamento: {LEGAL_UPDATED_AT}</p>
          <p>{policy.introduction}</p>
          <div className="legal-related">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
          </div>
          <button type="button" className="btn btn-outline-primary" onClick={openPreferences}>Modifica preferenze cookie</button>
        </header>
        <nav className="legal-index" aria-label="Indice dell’informativa">
          <ol>{policy.sections.map(section => <li key={section.id}><a href={`#${section.id}`}>{section.title}</a></li>)}</ol>
        </nav>
        {policy.sections.map(section => (
          <section key={section.id} id={section.id} aria-labelledby={`heading-${section.id}`}>
            <h2 id={`heading-${section.id}`}>{section.title}</h2>
            {section.paragraphs?.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
            {section.list && <ul>{section.list.map(item => <li key={item}>{item}</li>)}</ul>}
            {section.table && (
              <div className="legal-table-scroll" tabIndex={0} role="region" aria-label="Memorie tecniche e durate">
                <table>
                  <caption>Memorie utilizzate nel browser</caption>
                  <thead><tr>{section.table.headers.map(header => <th key={header} scope="col">{header}</th>)}</tr></thead>
                  <tbody>{section.table.rows.map(row => <tr key={row[0]}>{row.map((cell, index) => index === 0 ? <th key={index} scope="row">{cell}</th> : <td key={index}>{cell}</td>)}</tr>)}</tbody>
                </table>
              </div>
            )}
          </section>
        ))}
        <section aria-labelledby="legal-sources-heading">
          <h2 id="legal-sources-heading">Riferimenti e informative dei fornitori</h2>
          <ul>{LEGAL_SOURCES.map(source => <li key={source.url}><a href={source.url} target="_blank" rel="noopener noreferrer">{source.label}</a></li>)}</ul>
        </section>
        <p className="legal-contact">Richieste privacy: <a href="mailto:info@ceformedsrl.it">info@ceformedsrl.it</a></p>
      </article>
    </div>
  );
};

export default LegalPolicy;
